import { TextField } from '@mui/material';
import React, { memo } from 'react'
import { useRecoilState, useRecoilValue } from 'recoil';
import InputLabelCustom from 'src/shared/components/forms/InputLabelCustom';
import { cleanRut, formatRut, validateRutChilean } from 'src/shared/global/helpers';
import useAuthPatient from '../hooks/useAuthPatient';
import { errorsReservationUserState, valuesFormReservationUserState } from '../state/atoms';

const LoginField = memo(() => {

    const errorsReservationUser = useRecoilValue(errorsReservationUserState);
    const [valuesFormReservationUser, setValuesFormReservationUser] = useRecoilState(valuesFormReservationUserState)
    const { handleChange } = useAuthPatient();

    return (
        <>
            <InputLabelCustom htmlFor="input-usuario" text="RUT o correo electrónico" />
            <TextField
                id="input-usuario"
                size="small"
                error={errorsReservationUser['uswLogin'] && errorsReservationUser['uswLogin'].length > 0 ? true : false}
                helperText={errorsReservationUser['uswLogin'] && errorsReservationUser['uswLogin'].length > 0 ? `${errorsReservationUser['uswLogin'].join("\n")}` : ''}
                style={{ width: '100%' }}
                name="uswLogin"
                type="text"
                value={valuesFormReservationUser.uswLogin || ""}
                InputLabelProps={{
                    shrink: true,
                }}
                variant="outlined"
                onChange={handleChange}
                onBlur={(ev) => {
                    let { value } = ev.target;
                    if (value !== '' && !value.includes("@") && validateRutChilean(value).ok === true) {
                        value = formatRut(cleanRut(value))
                        setValuesFormReservationUser({
                            ...valuesFormReservationUser,
                            uswLogin: value
                        })
                    }
                }}
                autoComplete="off"
                placeholder="Ej: 16.000.000-0 o correo@dominio.cl"
            />
        </>
    )
})

export default LoginField;